import { CalendarClock, AlertCircle } from "lucide-react";
import { Card } from "@/components/ui/card";

const fmtBRL = (v) =>
  Number(v ?? 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

const fmtDate = (iso) => {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("pt-BR", { day: "2-digit", month: "short" });
  } catch {
    return "";
  }
};

export default function UpcomingPaymentsCard({ data }) {
  const items = data?.items || [];
  const days = data?.days_horizon ?? 7;

  return (
    <Card variant="elevated" className="p-4 max-w-md">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <div className="w-9 h-9 rounded-lg bg-amber-500/10 flex items-center justify-center">
            <CalendarClock className="w-4 h-4 text-amber-400" />
          </div>
          <div>
            <div className="text-xs text-foreground-muted">Próximos {days} dias</div>
            <div className="text-lg font-bold text-foreground">
              {data?.items_count ?? 0} {(data?.items_count ?? 0) === 1 ? "pagamento" : "pagamentos"}
            </div>
          </div>
        </div>
        {data?.total_amount > 0 && (
          <div className="text-right">
            <div className="text-[10px] text-foreground-muted">Total</div>
            <div className="text-sm font-semibold text-foreground">
              {fmtBRL(data.total_amount)}
            </div>
          </div>
        )}
      </div>

      {items.length > 0 ? (
        <div className="space-y-1.5">
          {items.slice(0, 6).map((it) => (
            <div
              key={it.id}
              className="flex items-center justify-between py-1.5 px-3 rounded-lg bg-surface-card-hover"
            >
              <div className="min-w-0 mr-2">
                <div className="text-xs text-foreground truncate">{it.title}</div>
                <div className="text-[10px] text-foreground-muted flex items-center gap-1">
                  {it.type === "subscription" ? "Assinatura" : "Lembrete"}
                  <span>·</span>
                  <span>{fmtDate(it.scheduled)}</span>
                </div>
              </div>
              {it.amount != null && it.amount > 0 && (
                <div className="text-xs font-semibold text-foreground whitespace-nowrap">
                  {fmtBRL(it.amount)}
                </div>
              )}
            </div>
          ))}
          {items.length > 6 && (
            <div className="text-[10px] text-foreground-muted text-center pt-1">
              + {items.length - 6} mais
            </div>
          )}
        </div>
      ) : (
        <div className="flex items-center gap-2 text-xs text-foreground-muted py-3">
          <AlertCircle className="w-3.5 h-3.5" />
          Nada a pagar nesse período.
        </div>
      )}
    </Card>
  );
}
